import request from '@/utils/request'

export function searchUid(data) {
  return request({
    url: 'api/v1/user/searchUid',
    method: 'post',
    data: data,
    timeout: 5000000
  })
}

export function sameUser(data) {
  return request({
    url: 'api/v1/user/sameUser',
    method: 'post',
    data: data,
    timeout: 5000000
  })
}
export function getUserRecordStat(data) {
  return request({
    url: 'api/v1/user/getUserRewardStat',
    method: 'post',
    data: data
  })
}

export function getUserSourceStat(data) {
  return request({
    url: 'api/v1/user/getUserSourceStat',
    method: 'post',
    data: data
  })
}

export function getUserSourceStat2(data) {
  return request({
    url: 'api/v1/user/getUserSourceStat2',
    method: 'post',
    data: data
  })
}
export function getUserPayOnlineStat(data) {
  return request({
    url: 'api/v1/user/getUserOnlineStat',
    method: 'post',
    data: data
  })
}
export function getUserBuildStat(data) {
  return request({
    url: 'api/v1/user/getUserBuildStat',
    method: 'post',
    data: data
  })
}
export function getShareStat(data) {
  return request({
    url: 'api/v1/user_remain/getShareStat',
    method: 'post',
    data: data
  })
}
export function getSpinPopUpStat(data) {
  return request({
    url: 'api/v1/user_remain/getSpinPopupStat',
    method: 'post',
    data: data
  })
}
export function getUserCardStat(data) {
  return request({
    url: 'api/v1/user_remain/getCardStatData',
    method: 'post',
    data: data
  })
}
export function getSpinProfitLossStat(data) {
  return request({
    url: 'api/v1/user_remain/getSpinProfitLossStat',
    method: 'post',
    data: data
  })
}
export function getActStageStat(data) {
  return request({
    url: 'api/v1/user_remain/getActStageData',
    method: 'post',
    data: data
  })
}
export function getSendSpinStat(data) {
  return request({
    url: 'api/v1/user_remain/getSendSpinStatData',
    method: 'post',
    data: data
  })
}
export function getSendCardStat(data) {
  return request({
    url: 'api/v1/user_remain/getSendCardRankData',
    method: 'post',
    data: data
  })
}
export function getBuyGamePassStat(data) {
  return request({
    url: 'api/v1/user/getBuyGamePassStat',
    method: 'post',
    data: data
  })
}
export function getGamePassTaskStat(data) {
  return request({
    url: 'api/v1/user/getGamePassTaskStat',
    method: 'post',
    data: data
  })
}
export function getAbnormalStat(data) {
  return request({
    url: 'api/v1/user/getAbnormalStat',
    method: 'post',
    data: data
  })
}
export function getBuyLevelGamePassStat(data) {
  return request({
    url: 'api/v1/user/getBuyLevelGamePassStat',
    method: 'post',
    data: data
  })
}
export function getUserUpLevelCountStat(data) {
  return request({
    url: 'api/v1/user/getUserUpLevelCountStat',
    method: 'post',
    data: data
  })
}
export function getUserLoginLevelStat(data) {
  return request({
    url: 'api/v1/user/getUserLoginLevelStat',
    method: 'post',
    data: data
  })
}

export function getUserUpLevelStat(data) {
  return request({
    url: 'api/v1/user/getUserUpLevelStat',
    method: 'post',
    data: data
  })
}
export function getUserUpLevelTimeStat(data) {
  return request({
    url: 'api/v1/user/getUserUpLevelTimeStat',
    method: 'post',
    data: data
  })
}
export function getUserBetStat(data) {
  return request({
    url: 'api/v1/user/getUserBetStat',
    method: 'post',
    data: data
  })
}
export function getPlayLevelStat(data) {
  return request({
    url: 'api/v1/user/getPlayStat',
    method: 'post',
    data: data
  })
}
export function getStealStrickStat(data) {
  return request({
    url: 'api/v1/user/getStealStrickStat',
    method: 'post',
    data: data
  })
}
export function getUserList(data) {
  return request({
    url: 'api/v1/user/getUser',
    method: 'post',
    data: data,
    timeout: 1000000
  })
}

export function getUserStat(data) {
  return request({
    url: 'api/v1/user/getUserStat',
    method: 'post',
    data: data
  })
}

export function getUserTotalStat(data) {
  return request({
    url: 'api/v1/user/getUserTotalStat',
    method: 'post',
    data: data
  })
}
export function getMaxLimit() {
  return request({
    url: 'api/v1/user/getMaxLimit',
    method: 'get'
  })
}
export function setMaxLimit(data) {
  return request({
    url: 'api/v1/user/setMaxLimit',
    method: 'post',
    data: data
  })
}
export function exportUserList(data) {
  return request({
    url: 'api/v1/user/exportUser',
    method: 'post',
    data: data,
    timeout: 100000
  })
}
export function exportUserStatList(data) {
  return request({
    url: 'api/v1/user/exportUserStat',
    method: 'post',
    data: data
  })
}
export function deleteUid(data) {
  return request({
    url: 'api/v1/user/delUid',
    method: 'delete',
    data: data
  })
}

export function changeUserAsset(data) {
  return request({
    url: 'api/v1/user/changeUserAssets',
    method: 'post',
    data: data
  })
}

export function getPropList(data) {
  return request({
    url: 'api/v1/user/getProp',
    method: 'post',
    data: data
  })
}

export function getCardList(data) {
  return request({
    url: 'api/v1/user/getCard',
    method: 'post',
    data: data
  })
}

export function getUserFriendList(data) {
  return request({
    url: 'api/v1/user/getUserFriend',
    method: 'post',
    data: data
  })
}

export function getUserWhiteList(data) {
  return request({
    url: 'api/v1/user/getUserWhite',
    method: 'post',
    data: data
  })
}

export function addUserWhite(data) {
  return request({
    url: 'api/v1/user/AddUserWhite',
    method: 'post',
    data: data
  })
}

export function delUserWhite(data) {
  return request({
    url: 'api/v1/user/delUserWhite',
    method: 'post',
    data: data
  })
}

export function getUserBeast(data) {
  return request({
    url: 'api/v1/user/getUserBeast',
    method: 'post',
    data: data
  })
}

export function getUserSieve(data) {
  return request({
    url: 'api/v1/user/getUserSieve',
    method: 'post',
    data: data
  })
}

export function getUserShield(data) {
  return request({
    url: 'api/v1/user/getUserShield',
    method: 'post',
    data: data
  })
}

export function getUserCard(data) {
  return request({
    url: 'api/v1/user/getUserCard',
    method: 'post',
    data: data
  })
}

export function sendReward(data) {
  return request({
    url: 'api/v1/user/sendReward',
    method: 'post',
    data: data
  })
}

export function getUserLoginLog(data) {
  return request({
    url: 'api/v1/user/getUserLoginLog',
    method: 'post',
    data: data
  })
}
